import React from "react";
import "./style.css";
import { formatDateToHumanReadable } from "../../../utils/utils";

function Close({ onClick }: { onClick: () => void }) {
  return (
    <button
      className="block cursor-pointer relative shrink-0 size-6"
      data-name="Close"
      onClick={onClick}
    >
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
      >
        <g id="Close">
          <path
            d="M18 6L6 18M6 6L18 18"
            id="Icon"
            stroke="var(--stroke-0, #211F26)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </svg>
    </button>
  );
}

function HDivider() {
  return (
    <div className="h-0 relative shrink-0 w-full" data-name="H Divider">
      <div
        className="absolute bottom-full left-0 right-0 top-0"
        data-name="H Divider"
      >
        <div className="absolute bottom-[-0.5px] left-[-0.125%] right-[-0.125%] top-[-0.5px]">
          <svg
            className="block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 402 2"
          >
            <path
              d="M1 1H401"
              id="H Divider"
              stroke="var(--stroke-0, #EAE7EC)"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default function CancelDowngrade({
  onClose,
  subscription,
}: {
  onClose: () => void;
  subscription: any;
}) {
  return (
    <div
      className="backdrop-blur-[20px] backdrop-filter bg-[rgba(255,255,255,0.72)] box-border content-stretch flex flex-col gap-2 h-[100vh] items-start justify-start p-[56px] relative rounded-tl-[24px] rounded-bl-[24px] shadow-[-4px_0px_24px_0px_rgba(0,0,0,0.02)] shrink-0"
      data-name="Create Workspace Modal"
    >
      <div className="box-border content-stretch flex flex-col gap-8 items-start justify-start p-0 relative shrink-0 w-[400px] h-full">
        <div className="box-border content-stretch flex flex-row gap-6 items-center justify-center p-0 relative shrink-0 w-full">
          <div className="basis-0 font-['Geist:Medium',_sans-serif] font-medium grow leading-[0] min-h-px min-w-px relative shrink-0 text-[#211f26] text-[24px] text-left tracking-[-0.24px]">
            <p className="block leading-[30px]">Downgrade cancelled</p>
          </div>
          <Close onClick={onClose} />
        </div>
        <HDivider />
        <div className="cancle-downgrade-text">
          <div>
            We’ve cancelled your scheduled downgrade to Plan{" "}
            {subscription.plan.name}, which was set for{" "}
            {subscription?.plan?.subscriptionEndDate
              ? formatDateToHumanReadable(
                  subscription?.plan?.subscriptionEndDate
                )
              : "-"}
            .
          </div>

          <br />
          <div>
            When your next billing cycle begins, you’ll continue to enjoy all
            the features of Plan {subscription.preDowngradeStripePriceData.name}{" "}
            without any changes.
          </div>
        </div>
        <div className="go-back-btn" onClick={onClose}>
          Go Back
        </div>
      </div>
    </div>
  );
}
